<datalist id="group-list">
  <option value="admin">
    <option value="office">
      <option value="support">
      </datalist>

      @if (form) {
        <form [id]="formElId">
          @for (field of form.fields; track field) {
            <div class="govuk-form-group">
              @if (field.type === 'dropdown') {
                <div>
                  <datalist id="{{field.id}}-list">
                    @for (option of field.options; track option) {
                      <div>
                        <option [value]="option.name">
                        </div>
                      }
                    </datalist>
                  </div>
                }
                <div>
                  @switch (field.type) {
                    @case ('headline-with-line') {
                      <span></span>
                    }
                    @case ('headline') {
                      <span></span>
                    }
                    @case ('horizontal-line') {
                      <span></span>
                    }
                    @case ('hyperlink') {
                      <span>
                        <label class="govuk-label">{{field.name}} @if (field.required) {
                          <span>*</span>
                        }</label>
                        <span class="govuk-hint">
                          {{field.placeholder === undefined ? '' : field.placeholder}}
                        </span>
                      </span>
                    }
                    @case ('upload') {
                      <span>
                        <label class="govuk-label">{{field.name}} @if (field.required) {
                          <span>*</span>
                        }</label>
                        <span class="govuk-hint">
                          {{field.placeholder === undefined ? '' : field.placeholder}}
                        </span>
                      </span>
                    }
                    @default {
                      <span>
                        <label class="govuk-label">{{field.name}} @if (field.required) {
                          <span>*</span>
                        }</label>
                        <span class="govuk-hint">
                          {{field.placeholder === undefined ? '' : field.placeholder}}
                        </span>
                      </span>
                    }
                  }
                </div>
                <div id="{{field.id}}-error" class="govuk-visually-hidden govuk-error-message"> </div>
                <div>
                  @switch (field.type) {
                    @case ('boolean') {
                      <div class="govuk-form-group">
                        <div class="govuk-checkboxes" data-module="govuk-checkboxes">
                          <div class="govuk-checkboxes__item">
                            <input class="govuk-checkboxes__input"
                              [id]="field.id"
                              [disabled]="field.readOnly ? 'disabled' : null"
                              [checked]="field.value"
                              [readonly]="field.readOnly ? 'readonly' : null"
                              required="{{field.required ? 'required': ''}}"
                              type="checkbox"
                              (input)="field.value=$event.target.checked"
                              (blur)="onBlurField($event)">
                            <label class="govuk-label govuk-checkboxes__label" [for]="field.id"> {{ field.value === true ? 'Yes' : 'No' }} </label>
                          </div>
                        </div>
                      </div>
                    }
                    @case ('decimal') {
                      <input class="govuk-input govuk-input--width-{{field.params === undefined ? '20' : field.params.maxLength === undefined ? '20' : field.params.maxLength}}"
                        [id]="field.id"
                        [disabled]="field.readOnly ? 'disabled' : null"
                        pattern="[0-9]*\.[0-9]*"
                        [readonly]="field.readOnly ? 'readonly' : null"
                        [required]="field.required ? 'required' : null"
                        type="numeric"
                        [value]="field.value"
                        (input)="field.value=$event.target.value"
                        (blur)="onBlurField($event)">
                    }
                    @case ('expression') {
                      <div [innerHtml]="field.value"></div>
                    }
                    @case ('headline-with-line') {
                      <h1 class="govuk-heading-l">{{field.name}}</h1>
                    }
                    @case ('headline') {
                      <h2 class="govuk-heading-m">{{field.name}}</h2>
                    }
                    @case ('horizontal-line') {
                      <hr>
                      }
                      @case ('hyperlink') {
                        <span>
                          @if (!field.readOnly) {
                            <div>
                              <input class="govuk-input govuk-input--width-{{field.params === undefined ? '20' : field.params.maxLength === undefined ? '20' : field.params.maxLength}}"
                                [id]="field.id"
                                required="{{field.required ? 'required': ''}}"
                                type="url"
                                [value]="field.value"
                                (input)="field.value=$event.target.value"
                                (blur)="onBlurField($event)">
                            </div>
                          }
                          @if (field.value !== undefined && field.value !== '') {
                            <a [href]="field.value">{{field.name}}</a>
                          }
                        </span>
                      }
                      @case ('multi-line-text') {
                        <textarea class="govuk-textarea"
                          [id]="field.id"
                          [disabled]="field.readOnly ? 'disabled' : null"
                          [readonly]="field.readOnly ? 'readonly' : null"
                          [required]="field.required ? 'required' : null"
                          rows="3"
                          [value]="field.value"
                          (input)="field.value=$event.target.value"
                        (blur)="onBlurField($event)"></textarea>
                      }
                      @case ('integer') {
                        <input class="govuk-input govuk-input--width-{{field.params === undefined ? '20' : field.params.maxLength === undefined ? '20' : field.params.maxLength}}"
                          [id]="field.id"
                          [disabled]="field.readOnly ? 'disabled' : null"
                          pattern="[0-9]*"
                          [readonly]="field.readOnly ? 'readonly' : null"
                          [required]="field.required ? 'required' : null"
                          type="numeric"
                          [value]="field.value"
                          (input)="field.value=$event.target.value"
                          (blur)="onBlurField($event)">
                      }
                      @case ('people') {
                        <input class="govuk-input govuk-input--width-{{field.params === undefined ? '20' : field.params.maxLength === undefined ? '20' : field.params.maxLength}}"
                          [id]="field.id"
                          [disabled]="field.readOnly ? 'disabled' : null"
                          [readonly]="field.readOnly ? 'readonly' : null"
                          [required]="field.required ? 'required' : null"
                          type="email"
                          [value]="field.value"
                          (input)="field.value=$event.target.value"
                          (blur)="onBlurField($event)">
                      }
                      @case ('radio-buttons') {
                        <div class="govuk-form-group">
                          <div class="govuk-radios">
                            @for (option of field.options; track option) {
                              <div class="govuk-radios__item">
                                @if (field.value !== option.name) {
                                  <input class="govuk-radios__input"
                                    [id]="field.id" type="radio"
                                    [name]="field.id" [value]="option.name"
                                    (blur)="onBlurField($event)">
                                }
                                @if (field.value === option.name) {
                                  <input class="govuk-radios__input"
                                    [id]="field.id" type="radio"
                                    checked
                                    [name]="field.id" [value]="option.name"
                                    (blur)="onBlurField($event)">
                                }
                                <label class="govuk-label govuk-radios__label" [for]="field.id">
                                  {{option.name}}
                                </label>
                              </div>
                            }
                          </div>
                        </div>
                      }
                      @case ('upload') {
                        <input class="govuk-input govuk-input--width-{{field.params === undefined ? '20' : field.params.maxLength === undefined ? '20' : field.params.maxLength}}"
                          [id]="field.id"
                          [disabled]="field.readOnly ? 'disabled' : null"
                          [readonly]="field.readOnly ? 'readonly' : null"
                          [required]="field.required ? 'required' : null"
                          type="file"
                          [value]="field.value"
                          (input)="field.value=$event.target.value">
                      }
                      @default {
                        <input class="govuk-input govuk-input--width-{{field.params === undefined ? '20' : field.params.maxLength === undefined ? '20' : field.params.maxLength}}"
                          [id]="field.id"
                          [disabled]="field.readOnly ? 'disabled' : null"
                          [readonly]="field.readOnly ? 'readonly' : null"
                          [required]="field.required ? 'required' : null"
                          [type]="field.type"
                          [attr.list]="field.id+'-list'"
                          [value]="field.value"
                          (input)="field.value=$event.target.value"
                          (blur)="onBlurField($event)">
                      }
                    }
                  </div>
                </div>
              }
            </form>
          }
